import {toast} from '@wandb/components';
import type {SelectedRunFile} from '@wandb/forge-shell-contract/aria';

import {isInIframe} from '../../../util/window';
import {runFilePart} from '../../chat/composer/runFile';
import {useWBAgentController} from '../../chat/controller';
import {useAgentChatReadonly} from '../../chat/useAgentChatReadonly';
import {entryPointPlaceholders} from '../suggestions/catalog';

export function useRunFileAttachment(file: SelectedRunFile | undefined) {
  const {isAvailable: isAriaAvailable, startChat} = useWBAgentController();
  const isReadonly = useAgentChatReadonly();
  const isAvailable = file != null && isAriaAvailable && !isInIframe();
  const isEnabled = isAvailable && !isReadonly;

  return {
    isAvailable,
    isEnabled,
    onAddToChat: () => {
      if (!isEnabled || !file) {
        return;
      }
      const result = startChat([], {
        delivery: 'draft',
        target: 'active-or-new',
        entryPoint: 'run_file',
        attachments: [runFilePart(file)],
        placeholder: entryPointPlaceholders.runFile,
      });
      if (!result.ok) {
        toast.error('Could not add the file to ARIA. Try again.');
      }
    },
  };
}
